// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"4b286a21","400":"9af87786"}[chunkId] + ".chunk.js";
};